import {getMAPIBaseUrl} from '@stencil/hotels-utils/src/common-utils';
import {UGC_REVIEWS_BASE_URL} from '../apiUrls';
import api from '@stencil/megatron/src/api';
import {getDeviceDetail} from '../apiUtils';
import {getExperimentData} from '@stencil/hotels-utils/src/get-experiment-data';

export const prepareUgcReviewsRequestData = ({flavour, requestDetails = {}, pokus = {}}) => {
  const isDesktop = flavour === 'desktop';

  return {
    deviceDetails: getDeviceDetail(isDesktop),
    expData: getExperimentData({pokus, additionalData: {UGCV2: 'T'}}),
    ...requestDetails,
  };
};

export const fetchUgcReviews = async ({requestData = {}, client = 'pwa', pokus}) => {
  const newRequestData = prepareUgcReviewsRequestData({
    flavour: client,
    requestDetails: requestData,
    pokus,
  });

  return await api.post(
    getMAPIBaseUrl(),
    UGC_REVIEWS_BASE_URL.replace(':client', client),
    newRequestData,
    true,
  );
};
